import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';
import { API_BASE_URL } from '../config';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [mqttConnected, setMqttConnected] = useState(false);
  const [workshopStates, setWorkshopStates] = useState({});
  const socketRef = useRef(null);

  useEffect(() => {
    const socket = io(API_BASE_URL);
    socketRef.current = socket;

    socket.on('mqtt_status', ({ connected }) => setMqttConnected(connected));

    socket.on('workshop_state_change', ({ workshop, action, operator }) => {
      setWorkshopStates(prev => ({
        ...prev,
        [workshop]: {
          status: action === 'ON' ? 'busy' : 'available',
          lockedBy: action === 'ON' ? operator : null,
        }
      }));
    });

    socket.on('all_workshops_reset', () => {
      setWorkshopStates({});
    });

    // Fetch initial MQTT status
    fetch(`${API_BASE_URL}/api/settings/mqtt-status`)
      .then(r => r.json())
      .then(d => setMqttConnected(d.connected))
      .catch(() => {});

    return () => socket.disconnect();
  }, []);

  function updateWorkshopState(workshop, action, operator) {
    setWorkshopStates(prev => ({
      ...prev,
      [workshop]: {
        status: action === 'ON' ? 'busy' : 'available',
        lockedBy: action === 'ON' ? operator : null,
      }
    }));
  }

  return (
    <SocketContext.Provider value={{ mqttConnected, workshopStates, setWorkshopStates, updateWorkshopState }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
